// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCustomButton = () => import('@/components/DdCustomButton')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')
const ThKoteiKamotsuNoTextBox = () => import('@/components/ThKoteiKamotsuNoTextBox')

export default {
  name: 'DdHaishaSagyoEditDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdDateBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSectionTitle,
    DdSubHeader,
    DdTextBox,
    DdTimeBox,
    ThKoteiKamotsuNoTextBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 受注情報構造体
     */
    dataSource: Object,
    /**
    * 読取モード
    */
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
    * 時刻必須モード
    */
    isRequiredHms: {
      type: Boolean,
      default: false
    },
    /**
    * 配車年月日
    */
    unkoYmd: {
      type: String,
      default: filter.dateFormatter(new Date())
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    // 戻り値用定義
    vwCD2plmd00102: {},
    tempVwCD2plmd00102: {},
    /*
    rec: {
      id: 0,
      juchuNo: '',
      juchuYmd: '',
      juchuEigyosho: '',
      uriageSbt: '',
      chumonNo: '',
      sagyoYoteiYmd: '',
      sagyoEigyosho: '',
      tokuisaki: '',
      hatsuchiYmd: '',
      hatsuchiHms: '',
      hatsuHmsFixed: false,
      oroshisaki: '',
      chakuchiYmd: '',
      chakuchiHms: '',
      chakuHmsFixed: false,
      chipColor: ''
    },
    */
    // 作業変数定義
    colorDialog: false,
    chipColorTmp: '',
    expandKeiyuchi: false,
    // 表示制御
    modeKengen: 0
  }),

  created () {
    this.initialize()
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)
  },

  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
    /*
    'rec.juchuYmd': function (n) {
      if (this.rec.sagyoYoteiYmd === '') {
        this.rec.sagyoYoteiYmd = n
      }
      if (this.rec.hatsuchiYmd === '') {
        this.rec.hatsuchiYmd = n
      }
      if (this.rec.chakuchiYmd === '') {
        this.rec.chakuchiYmd = n
      }
    },
    'rec.juchuEigyosho': function (n) {
      if (this.rec.sagyoEigyosho === '') {
        this.rec.sagyoEigyosho = this.rec.juchuEigyosho
      }
    }
    */
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      sharyoList: 'DDMasters/vwCMstSharyo',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyosho: 'users/eigyoshoCd'
    }),

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    /*
    filteredHaishaSharyoShubetsList () {
      // return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
      return ['', '佐川', 'Amazon/郵便', '（南総）路線', '（南総）集荷']
    },
    filteredKamotsuShubetsList () {
      return ['', '路線', '本線', '集配', '定期', '臨時', 'その他']
    },
    */
    dispCreateButton () {
      return this.modeKengen !== 0
    },
    dispDeleteButton () {
      console.log('dispDeleteButton', this.modeKengen, this.vwCD2plmd00102.id)
      return this.modeKengen === 2 && this.vwCD2plmd00102.id !== 'NEW' && this.vwCD2plmd00102.id !== -1
    },
    readOnlyMode () {
      console.log('readOnlyMode', this.readOnly, this.vwCD2plmd00102.kakuteiFlg)
      return this.readOnly || this.vwCD2plmd00102.kakuteiFlg
    }
  },
  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForRegister(option)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.vwCD2plmd00102 = {}
      this.clearInvalidMessage(this.$refs)
      this.chipColorTmp = '#00FF00'

      if ((this.dataSource) && this.dataSource !== null) {
        var initVwCD2plmd00102 = Object.assign({}, this.dataSource)
        if (initVwCD2plmd00102.id === 'NEW') {
          const today = filter.dateFormatter(new Date())
          initVwCD2plmd00102 = {
            ...initVwCD2plmd00102,
            kakuteiFlg: false,
            sagyoYmd: this.unkoYmd,
            sagyoEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, today).id : null,
            endYmd: initVwCD2plmd00102.startYmd,
            startLockFlg: true,
            endLockFlg: false,
            shujitsuFlg: false
          }
        } else if (initVwCD2plmd00102.id) {
          initVwCD2plmd00102.trSagyoMeisaiInsDateTime = filter.dateYmdHmsFormatter(initVwCD2plmd00102.trSagyoMeisaiInsDate)
          var iUser = indexeddb.getRecord(this.eigyoshoJininList, initVwCD2plmd00102.trSagyoMeisaiInsUserId)
          if (iUser) {
            initVwCD2plmd00102.trSagyoMeisaiInsUserCdNm = iUser.jininCd + ':' + iUser.jininNmSei
          }
          initVwCD2plmd00102.trSagyoMeisaiUpdDateTime = filter.dateYmdHmsFormatter(initVwCD2plmd00102.trSagyoMeisaiUpdDate)
          var uUser = indexeddb.getRecord(this.eigyoshoJininList, initVwCD2plmd00102.trSagyoMeisaiUpdUserId)
          if (uUser) {
            initVwCD2plmd00102.trSagyoMeisaiUpdUserCdNm = uUser.jininCd + ':' + uUser.jininNmSei
          }
          initVwCD2plmd00102.kakuteiFlg = this.isRequiredHms ? initVwCD2plmd00102.kakuteiFlg : false
        }
        this.vwCD2plmd00102 = Object.assign({}, initVwCD2plmd00102)
        this.tempVwCD2plmd00102 = Object.assign({}, this.vwCD2plmd00102)
      }
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    },
    // --------------------------------------------------------------------------------
    // キャンセルボタン押下
    // --------------------------------------------------------------------------------
    onCancelClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.vwCD2plmd00102 = Object.assign({}, this.tempVwCD2plmd00102)
        this.Effects.loadComplete()
      })
    },
    // --------------------------------------------------------------------------------
    // 削除ボタン押下
    // --------------------------------------------------------------------------------
    onDeleteClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plmd00102/SagyoDelete', self.vwCD2plmd00102).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            self.$emit('delete', self.vwCD2plmd00102)
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        const x = this.vwCD2plmd00102
        x.id = -1
        x.trSagyoKeikakuKihonId = null
        x.trSagyoKeikakuMeisaiId = null
        x.trJuhacchusagyoRelationId = null
        x.sagyoMeisaiNo = null
        x.kakuteiFlg = false

        this.vwCD2plmd00102 = x
        this.Effects.loadComplete()
      })
    },
    // --------------------------------------------------------------------------------
    // 保存ボタン押下
    // --------------------------------------------------------------------------------
    onSaveClick: function (e) {
      /*
      var vwCD2plmd00102 = {
        id: 'NEW',
        sagyoEigyoshoId: this.rec.sagyoEigyosho,
        sagyoEigyoshoCd: null,
        sagyoEigyoshoNm: null,
        trSagyoKeikakuId: null,
        haishaShashuSbt: null,
        sagyoYoteiYmd: null,
        trJuchuKihonId: 0,
        trJuchuMeisaiId: 0,
        juchuNo: 'JX000001',
        juchuYmd: this.rec.juchuYmd,
        juchuEigyosho: this.rec.juchuEigyosho,
        uruageEigyosho: this.rec.sagyoEigyosho,
        ninushiNm: '得意先１',
        hatsuchiNm: 'ダミー１',
        hatsuchiYmd: this.rec.hatsuchiYmd,
        hatsuchiHms: '10:00',
        chakuchiNm: 'ダミー２',
        chakuchiYmd: this.rec.chakuchiYmd,
        chakuchiHms: '17:00',
        kamotsuKbn: '01',
        shujitsuFlg: false,
        startLockFlg: false,
        endLockFlg: false

      }
      */
      if (this.vwCD2plmd00102.id === 'NEW') {
        this.vwCD2plmd00102.id = -1
      }
      this.onSaveAction()
    },
    onSaveAction: function () {
      const tempKakuteiFlg = this.vwCD2plmd00102.kakuteiFlg
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.vwCD2plmd00102 = data.payload
            if (self.vwCD2plmd00102.sagyoYmd) { self.vwCD2plmd00102.sagyoYmd = filter.dateFormatter(self.vwCD2plmd00102.sagyoYmd) }
            if (self.vwCD2plmd00102.startYmd) { self.vwCD2plmd00102.startYmd = filter.dateFormatter(self.vwCD2plmd00102.startYmd) }
            if (self.vwCD2plmd00102.startHms) { self.vwCD2plmd00102.startHms = (self.vwCD2plmd00102.startHms).slice(0, 5) }
            if (self.vwCD2plmd00102.endYmd) { self.vwCD2plmd00102.endYmd = filter.dateFormatter(self.vwCD2plmd00102.endYmd) }
            if (self.vwCD2plmd00102.endHms) { self.vwCD2plmd00102.endHms = (self.vwCD2plmd00102.endHms).slice(0, 5) }
            self.vwCD2plmd00102.kakuteiFlg = tempKakuteiFlg

            this.$emit('save', self.vwCD2plmd00102)
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.rec.vwJuchuKihon.id })
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isNoMessageModeMethod: function () {
          return true
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      const f = this.HttpClient.post('/api/v1/VwCD2plmd00102/SagyoCreate', this.vwCD2plmd00102)
      return f
    },
    registerValidate: function () {
      var msg
      if (!this.vwCD2plmd00102.sagyoYmd) {
        this.$refs.sagyoYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00102.sagyoEigyoshoId) {
        this.$refs.sagyoEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00102.startYmd) {
        this.$refs.startYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00102.startHms && this.isRequiredHms) {
        this.$refs.startHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00102.endYmd) {
        this.$refs.endYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00102.endHms && this.isRequiredHms) {
        this.$refs.endHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (this.vwCD2plmd00102.startYmd && this.vwCD2plmd00102.endYmd) {
        msg = validators.compareDate(this.vwCD2plmd00102.startYmd, this.vwCD2plmd00102.endYmd)
        if (msg !== undefined) {
          this.$refs.startYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.endYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.vwCD2plmd00102.startYmd && this.vwCD2plmd00102.startHms && this.vwCD2plmd00102.endYmd && this.vwCD2plmd00102.endHms) {
        msg = validators.compareDateTime(this.vwCD2plmd00102.startYmd, this.vwCD2plmd00102.startHms, this.vwCD2plmd00102.endYmd, this.vwCD2plmd00102.endHms)
        if (msg !== undefined) {
          this.$refs.startYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.startHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.endYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.endHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.vwCD2plmd00102.startYmd === this.vwCD2plmd00102.endYmd && this.vwCD2plmd00102.startHms === this.vwCD2plmd00102.endHms) {
        this.$refs.startHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['同日の開始時刻', '同日の開始時刻']))
        this.$refs.endHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['同日の終了時刻', '同日の終了時刻']))
        return false
      }
      return true
    }
  }
}
